import { render, staticRenderFns } from "./LibraryEditField.vue?vue&type=template&id=4b89a2c1&scoped=true&"
import script from "./LibraryEditField.vue?vue&type=script&lang=js&"
export * from "./LibraryEditField.vue?vue&type=script&lang=js&"
import style0 from "./LibraryEditField.vue?vue&type=style&index=0&id=4b89a2c1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b89a2c1",
  null
  
)

export default component.exports